export interface CancelCollectionReserveRequest {
  id: number
  collectionNo: string
}

export function CancelCollectionReserveRequestToJSON(
  value: CancelCollectionReserveRequest
): any {
  return {
    id: value.id !== 0 ? value.id : undefined,
    collection_no: value.collectionNo !== '' ? value.collectionNo : undefined
  }
}
